import React from "react";
import type { SVGProps } from "react";

export type CentralIconBaseProps = {
  size?: string | number;
  ariaHidden?: boolean;
  mode?: "masked" | "raw";
  maskId?: string;
} & SVGProps<SVGSVGElement>;

export const CentralIconBase: React.FC<
  CentralIconBaseProps & { ariaLabel?: string }
> = ({
  children,
  size = 24,
  ariaLabel,
  color,
  ariaHidden = true,
  style,
  mode = "masked",
  maskId,
  ...props
}) => {
  const masked = mode !== "raw" && !!maskId;
  return (
    <svg
      {...props}
      aria-hidden={ariaHidden}
      role={ariaHidden ? undefined : "img"}
      width={typeof size === "number" ? `${size}px` : size}
      height={typeof size === "number" ? `${size}px` : size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color, ...style }}
    >
      {ariaLabel && !ariaHidden && <title>{ariaLabel}</title>}
      {masked ? (
        <>
          <mask
            id={maskId}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect width="24" height="24" fill="#000" />
            <g fill="none" style={{ color: "#fff" }}>
              {children}
            </g>
          </mask>
          <rect
            width="24"
            height="24"
            fill="currentColor"
            mask={`url(#${maskId})`}
          />
        </>
      ) : (
        children
      )}
    </svg>
  );
};
